import Image from '@/components/UI/Image';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
// 2022-01-27 k.w 轮播组件

const defaultStyle = {
    theme: 'white',
    fullScreen: true, // 是否全屏
    textStyle: {
        width: '100%',
        marginTop: '.16rem',
        textAlign: 'center',
        lineHeight: '.22rem',
        fontSize: '.14rem',
        color: 'rgb(34,34,34)',
        fontFamily: 'var(--font-family-Medium)',
        fontWeight: 500,
    },
};
const defaultData = [
    { img: '/img/banner_house_big.jpg', desc: '' },
    { img: '/img/banner_cell_big.jpg', desc: '' },
    { img: '/img/banner_house_big.jpg', desc: '' },
    { img: '/img/banner_cell_big.jpg', desc: '' },
];

export default function CustomerSwiper({ data = defaultData, cssStyle = defaultStyle }: any) {
    const styles = {
        theme: cssStyle?.theme ?? defaultStyle.theme,
        fullScreen: cssStyle?.fullScreen ?? defaultStyle.fullScreen,
        textStyle: { ...defaultStyle.textStyle, ...cssStyle?.textStyle },
        webpUrl: cssStyle?.webpUrl,
    };
    const { theme, fullScreen, textStyle, webpUrl } = styles;
    const { useState, useRef, useEffect } = useGlobal();
    const { EFPic } = createEFPic(webpUrl);

    // 背景主题
    const isWhiteTheme = theme === 'white' || theme === '#fff' || theme === '#ffffff' || theme === 'transparent';

    // 多添加首尾各一项，以实现轮播无缝连接
    const items = [data[data.length - 1], ...data, data[0]];

    const listContainerRef = useRef();
    const [activeKey, setActiveKey] = useState({ key: 0, flag: 0 });

    let startX = 0,
        endX = 0;
    const touchStart = (e: any) => {
        startX = e.changedTouches[0].clientX || 0;
    };

    const touchEnd = (e: any) => {
        endX = e.changedTouches[0].clientX || 0;
        if (endX > startX) {
            if (activeKey.key <= 0) {
                setActiveKey({ key: data.length - 1, flag: -1 });
            } else {
                setActiveKey({ key: activeKey.key - 1, flag: 0 });
            }
        }
        if (endX < startX) {
            if (activeKey.key >= data.length - 1) {
                setActiveKey({ key: 0, flag: 1 });
            } else {
                setActiveKey({ key: activeKey.key + 1, flag: 0 });
            }
        }
    };

    // js动效
    const animate = (activeKey: any) => {
        const originX = parseFloat(listContainerRef?.current?.style?.transform.split('(')[1]) || -100;
        const add = activeKey.flag === -1 ? 0 : activeKey.flag === 1 ? -100 * (items.length - 1) : -100 * (activeKey.key + 1);
        listContainerRef?.current?.animate([{ transform: `translateX(${originX}vw)` }, { transform: `translateX(${add}vw)` }], {
            duration: originX === add ? 0 : 300,
            delay: 0,
            fill: 'forwards',
            easing: 'linear',
            iterations: 1,
        });
        switch (activeKey.flag) {
            case -1:
                listContainerRef.current.style.transform = `translateX(${-100 * data.length}vw)`;
                break;
            case 1:
                listContainerRef.current.style.transform = `translateX(-100vw)`;
                break;
            case 0:
                listContainerRef.current.style.transform = `translateX(${add}vw)`;
                break;
            default:
                console.error("customer swiper's activeKey object goes wrong!");
        }
    };

    useEffect(() => {
        animate(activeKey);
    }, [activeKey]);

    return (
        <div className={`${css.customerSwiper} customerSwiper ${isWhiteTheme ? '' : 'black'}`} style={{ background: isWhiteTheme ? '#fff' : '#000' }}>
            <div className="cardSliderWrapper" style={{ width: '100vw' }}>
                <ul className="listBox" ref={listContainerRef} onTouchStart={touchStart} onTouchEnd={touchEnd}>
                    {items.map((item: any, k: number) => (
                        <li className="list" key={k}>
                            <div
                                className="listImgBox"
                                style={{
                                    width: fullScreen ? '100vw' : '3.55rem',
                                    height: fullScreen ? '5rem' : '3.6rem',
                                    borderRadius: fullScreen ? 'none' : '.2rem',
                                }}
                            >
                                {Array.isArray(item?.img) ? (
                                    <EFPic name={item.img} className="fullImgs" alt={item.alt} />
                                ) : (
                                    <Image src={item.img} className="fullImgs" layout="fill" alt={item.alt} />
                                )}
                            </div>
                            <p
                                className="descText"
                                style={{
                                    ...textStyle,
                                    ...{
                                        display: item.desc ? 'block' : 'none',
                                    },
                                }}
                            >
                                {item.desc}
                            </p>
                        </li>
                    ))}
                </ul>
                <div
                    className="pagination"
                    style={{
                        display: data.length > 1 ? '' : 'none',
                        top: fullScreen ? '4.74rem' : '3.4rem',
                    }}
                >
                    {data.map((_list: any, k: number) => (
                        <li className={`paginationDot ${k === activeKey.key ? 'activeDot' : ''}`} key={k}></li>
                    ))}
                </div>
            </div>
        </div>
    );
}
